<app-payment-panel-stripe-generic
  [type]="paymentMethodHandles.StripeGooglePay"
  [isPayButtonVisible]="false"
></app-payment-panel-stripe-generic>
